// extracted by mini-css-extract-plugin
export default {"moreIcon":"SidebarSettingsNavItem-module__moreIcon--Qik0x"};